function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var SplayTreeNode = function SplayTreeNode(key) {
    "use strict";
    _class_call_check(this, SplayTreeNode);
    _define_property(this, "key", void 0);
    _define_property(this, "left", null);
    _define_property(this, "right", null);
    this.key = key;
};
var SplayTreeSetNode = /*#__PURE__*/ function(SplayTreeNode) {
    "use strict";
    _inherits(SplayTreeSetNode, SplayTreeNode);
    function SplayTreeSetNode(key) {
        _class_call_check(this, SplayTreeSetNode);
        return _call_super(this, SplayTreeSetNode, [
            key
        ]);
    }
    return SplayTreeSetNode;
}(SplayTreeNode);
var SplayTreeMapNode = /*#__PURE__*/ function(SplayTreeNode) {
    "use strict";
    _inherits(SplayTreeMapNode, SplayTreeNode);
    function SplayTreeMapNode(key, value) {
        _class_call_check(this, SplayTreeMapNode);
        var _this;
        _this = _call_super(this, SplayTreeMapNode, [
            key
        ]), _define_property(_this, "value", void 0);
        _this.value = value;
        return _this;
    }
    _create_class(SplayTreeMapNode, [
        {
            key: "replaceValue",
            value: function replaceValue(value) {
                var node = new SplayTreeMapNode(this.key, value);
                node.left = this.left;
                node.right = this.right;
                return node;
            }
        }
    ]);
    return SplayTreeMapNode;
}(SplayTreeNode);
var SplayTree = /*#__PURE__*/ function() {
    "use strict";
    function SplayTree() {
        _class_call_check(this, SplayTree);
        _define_property(this, "size", 0);
        _define_property(this, "modificationCount", 0);
        _define_property(this, "splayCount", 0);
    }
    _create_class(SplayTree, [
        {
            key: "splay",
            value: function splay(key) {
                var root = this.root;
                if (root == null) {
                    this.compare(key, key);
                    return -1;
                }
                var right = null;
                var newTreeRight = null;
                var left = null;
                var newTreeLeft = null;
                var current = root;
                var compare = this.compare;
                var comp;
                while(true){
                    comp = compare(current.key, key);
                    if (comp > 0) {
                        var currentLeft = current.left;
                        if (currentLeft == null) break;
                        comp = compare(currentLeft.key, key);
                        if (comp > 0) {
                            current.left = currentLeft.right;
                            currentLeft.right = current;
                            current = currentLeft;
                            currentLeft = current.left;
                            if (currentLeft == null) break;
                        }
                        if (right == null) {
                            newTreeRight = current;
                        } else {
                            right.left = current;
                        }
                        right = current;
                        current = currentLeft;
                    } else if (comp < 0) {
                        var currentRight = current.right;
                        if (currentRight == null) break;
                        comp = compare(currentRight.key, key);
                        if (comp < 0) {
                            current.right = currentRight.left;
                            currentRight.left = current;
                            current = currentRight;
                            currentRight = current.right;
                            if (currentRight == null) break;
                        }
                        if (left == null) {
                            newTreeLeft = current;
                        } else {
                            left.right = current;
                        }
                        left = current;
                        current = currentRight;
                    } else {
                        break;
                    }
                }
                if (left != null) {
                    left.right = current.left;
                    current.left = newTreeLeft;
                }
                if (right != null) {
                    right.left = current.right;
                    current.right = newTreeRight;
                }
                if (this.root !== current) {
                    this.root = current;
                    this.splayCount++;
                }
                return comp;
            }
        },
        {
            key: "splayMin",
            value: function splayMin(node) {
                var current = node;
                var nextLeft = current.left;
                while(nextLeft != null){
                    var left = nextLeft;
                    current.left = left.right;
                    left.right = current;
                    current = left;
                    nextLeft = current.left;
                }
                return current;
            }
        },
        {
            key: "splayMax",
            value: function splayMax(node) {
                var current = node;
                var nextRight = current.right;
                while(nextRight != null){
                    var right = nextRight;
                    current.right = right.left;
                    right.left = current;
                    current = right;
                    nextRight = current.right;
                }
                return current;
            }
        },
        {
            key: "_delete",
            value: function _delete(key) {
                if (this.root == null) return null;
                var comp = this.splay(key);
                if (comp != 0) return null;
                var root = this.root;
                var result = root;
                var left = root.left;
                this.size--;
                if (left == null) {
                    this.root = root.right;
                } else {
                    var right = root.right;
                    root = this.splayMax(left);
                    root.right = right;
                    this.root = root;
                }
                this.modificationCount++;
                return result;
            }
        },
        {
            key: "addNewRoot",
            value: function addNewRoot(node, comp) {
                this.size++;
                this.modificationCount++;
                var root = this.root;
                if (root == null) {
                    this.root = node;
                    return;
                }
                if (comp < 0) {
                    node.left = root;
                    node.right = root.right;
                    root.right = null;
                } else {
                    node.right = root;
                    node.left = root.left;
                    root.left = null;
                }
                this.root = node;
            }
        },
        {
            key: "_first",
            value: function _first() {
                var root = this.root;
                if (root == null) return null;
                this.root = this.splayMin(root);
                return this.root;
            }
        },
        {
            key: "_last",
            value: function _last() {
                var root = this.root;
                if (root == null) return null;
                this.root = this.splayMax(root);
                return this.root;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.root = null;
                this.size = 0;
                this.modificationCount++;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.validKey(key) && this.splay(key) == 0;
            }
        },
        {
            key: "defaultCompare",
            value: function defaultCompare() {
                return function(a, b) {
                    return a < b ? -1 : a > b ? 1 : 0;
                };
            }
        },
        {
            key: "wrap",
            value: function wrap() {
                var _this = this;
                return {
                    getRoot: function() {
                        return _this.root;
                    },
                    setRoot: function(root) {
                        _this.root = root;
                    },
                    getSize: function() {
                        return _this.size;
                    },
                    getModificationCount: function() {
                        return _this.modificationCount;
                    },
                    getSplayCount: function() {
                        return _this.splayCount;
                    },
                    setSplayCount: function(count) {
                        _this.splayCount = count;
                    },
                    splay: function(key) {
                        return _this.splay(key);
                    },
                    has: function(key) {
                        return _this.has(key);
                    }
                };
            }
        }
    ]);
    return SplayTree;
}();
var _Symbol_iterator = Symbol.iterator, _Symbol_toStringTag = Symbol.toStringTag;
export var SplayTreeMap = /*#__PURE__*/ function(SplayTree) {
    "use strict";
    _inherits(SplayTreeMap, SplayTree);
    function SplayTreeMap(compare, isValidKey) {
        _class_call_check(this, SplayTreeMap);
        var _this;
        _this = _call_super(this, SplayTreeMap), _define_property(_this, "root", null), _define_property(_this, "compare", void 0), _define_property(_this, "validKey", void 0), _define_property(_this, _Symbol_toStringTag, '[object Map]');
        _this.compare = compare !== null && compare !== void 0 ? compare : _this.defaultCompare();
        _this.validKey = isValidKey !== null && isValidKey !== void 0 ? isValidKey : function(a) {
            return a != null && a != undefined;
        };
        return _this;
    }
    _create_class(SplayTreeMap, [
        {
            key: "delete",
            value: function _delete(key) {
                if (!this.validKey(key)) return false;
                return this._delete(key) != null;
            }
        },
        {
            key: "forEach",
            value: function forEach(f) {
                var nodes = new SplayTreeMapEntryIterableIterator(this.wrap());
                var result;
                while(result = nodes.next(), !result.done){
                    f(result.value[1], result.value[0], this);
                }
            }
        },
        {
            key: "get",
            value: function get(key) {
                if (!this.validKey(key)) return undefined;
                if (this.root != null) {
                    var comp = this.splay(key);
                    if (comp == 0) {
                        return this.root.value;
                    }
                }
                return undefined;
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                var _this = this;
                var initialSplayCount = this.splayCount;
                var visit = function(node) {
                    while(node != null){
                        if (node.value == value) return true;
                        if (initialSplayCount != _this.splayCount) {
                            throw "Concurrent modification during iteration.";
                        }
                        if (node.right != null && visit(node.right)) {
                            return true;
                        }
                        node = node.left;
                    }
                    return false;
                };
                return visit(this.root);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var comp = this.splay(key);
                if (comp == 0) {
                    this.root = this.root.replaceValue(value);
                    this.splayCount += 1;
                    return this;
                }
                this.addNewRoot(new SplayTreeMapNode(key, value), comp);
                return this;
            }
        },
        {
            key: "setAll",
            value: function setAll(other) {
                var _this = this;
                other.forEach(function(value, key) {
                    _this.set(key, value);
                });
            }
        },
        {
            key: "setIfAbsent",
            value: function setIfAbsent(key, ifAbsent) {
                var comp = this.splay(key);
                if (comp == 0) {
                    return this.root.value;
                }
                var modificationCount = this.modificationCount;
                var splayCount = this.splayCount;
                var value = ifAbsent();
                if (modificationCount != this.modificationCount) {
                    throw "Concurrent modification during iteration.";
                }
                if (splayCount != this.splayCount) {
                    comp = this.splay(key);
                }
                this.addNewRoot(new SplayTreeMapNode(key, value), comp);
                return value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.root == null;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty() {
                return !this.isEmpty();
            }
        },
        {
            key: "firstKey",
            value: function firstKey() {
                if (this.root == null) return null;
                return this._first().key;
            }
        },
        {
            key: "lastKey",
            value: function lastKey() {
                if (this.root == null) return null;
                return this._last().key;
            }
        },
        {
            key: "lastKeyBefore",
            value: function lastKeyBefore(key) {
                if (key == null) throw "Invalid arguments(s)";
                if (this.root == null) return null;
                var comp = this.splay(key);
                if (comp < 0) return this.root.key;
                var node = this.root.left;
                if (node == null) return null;
                var nodeRight = node.right;
                while(nodeRight != null){
                    node = nodeRight;
                    nodeRight = node.right;
                }
                return node.key;
            }
        },
        {
            key: "firstKeyAfter",
            value: function firstKeyAfter(key) {
                if (key == null) throw "Invalid arguments(s)";
                if (this.root == null) return null;
                var comp = this.splay(key);
                if (comp > 0) return this.root.key;
                var node = this.root.right;
                if (node == null) return null;
                var nodeLeft = node.left;
                while(nodeLeft != null){
                    node = nodeLeft;
                    nodeLeft = node.left;
                }
                return node.key;
            }
        },
        {
            key: "update",
            value: function update(key, update, ifAbsent) {
                var comp = this.splay(key);
                if (comp == 0) {
                    var modificationCount = this.modificationCount;
                    var splayCount = this.splayCount;
                    var newValue = update(this.root.value);
                    if (modificationCount != this.modificationCount) {
                        throw "Concurrent modification during iteration.";
                    }
                    if (splayCount != this.splayCount) {
                        this.splay(key);
                    }
                    this.root = this.root.replaceValue(newValue);
                    this.splayCount += 1;
                    return newValue;
                }
                if (ifAbsent != null) {
                    var modificationCount1 = this.modificationCount;
                    var splayCount1 = this.splayCount;
                    var newValue1 = ifAbsent();
                    if (modificationCount1 != this.modificationCount) {
                        throw "Concurrent modification during iteration.";
                    }
                    if (splayCount1 != this.splayCount) {
                        comp = this.splay(key);
                    }
                    this.addNewRoot(new SplayTreeMapNode(key, newValue1), comp);
                    return newValue1;
                }
                throw "Invalid argument (key): Key not in map.";
            }
        },
        {
            key: "updateAll",
            value: function updateAll(update) {
                var root = this.root;
                if (root == null) return;
                var iterator = new SplayTreeMapEntryIterableIterator(this.wrap());
                var node;
                while(node = iterator.next(), !node.done){
                    var newValue = update.apply(void 0, _to_consumable_array(node.value));
                    iterator.replaceValue(newValue);
                }
            }
        },
        {
            key: "keys",
            value: function keys() {
                return new SplayTreeKeyIterableIterator(this.wrap());
            }
        },
        {
            key: "values",
            value: function values() {
                return new SplayTreeValueIterableIterator(this.wrap());
            }
        },
        {
            key: "entries",
            value: function entries() {
                return this[Symbol.iterator]();
            }
        },
        {
            key: _Symbol_iterator,
            value: function value() {
                return new SplayTreeMapEntryIterableIterator(this.wrap());
            }
        }
    ]);
    return SplayTreeMap;
}(SplayTree);
var _Symbol_iterator1 = Symbol.iterator, _Symbol_toStringTag1 = Symbol.toStringTag;
export var SplayTreeSet = /*#__PURE__*/ function(SplayTree) {
    "use strict";
    _inherits(SplayTreeSet, SplayTree);
    function SplayTreeSet(compare, isValidKey) {
        _class_call_check(this, SplayTreeSet);
        var _this;
        _this = _call_super(this, SplayTreeSet), _define_property(_this, "root", null), _define_property(_this, "compare", void 0), _define_property(_this, "validKey", void 0), _define_property(_this, _Symbol_toStringTag1, '[object Set]');
        _this.compare = compare !== null && compare !== void 0 ? compare : _this.defaultCompare();
        _this.validKey = isValidKey !== null && isValidKey !== void 0 ? isValidKey : function(v) {
            return v != null && v != undefined;
        };
        return _this;
    }
    _create_class(SplayTreeSet, [
        {
            key: "delete",
            value: function _delete(element) {
                if (!this.validKey(element)) return false;
                return this._delete(element) != null;
            }
        },
        {
            key: "deleteAll",
            value: function deleteAll(elements) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        this.delete(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "forEach",
            value: function forEach(f) {
                var nodes = this[Symbol.iterator]();
                var result;
                while(result = nodes.next(), !result.done){
                    f(result.value, result.value, this);
                }
            }
        },
        {
            key: "add",
            value: function add(element) {
                var compare = this.splay(element);
                if (compare != 0) this.addNewRoot(new SplayTreeSetNode(element), compare);
                return this;
            }
        },
        {
            key: "addAndReturn",
            value: function addAndReturn(element) {
                var compare = this.splay(element);
                if (compare != 0) this.addNewRoot(new SplayTreeSetNode(element), compare);
                return this.root.key;
            }
        },
        {
            key: "addAll",
            value: function addAll(elements) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        this.add(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.root == null;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty() {
                return this.root != null;
            }
        },
        {
            key: "single",
            value: function single() {
                if (this.size == 0) throw "Bad state: No element";
                if (this.size > 1) throw "Bad state: Too many element";
                return this.root.key;
            }
        },
        {
            key: "first",
            value: function first() {
                if (this.size == 0) throw "Bad state: No element";
                return this._first().key;
            }
        },
        {
            key: "last",
            value: function last() {
                if (this.size == 0) throw "Bad state: No element";
                return this._last().key;
            }
        },
        {
            key: "lastBefore",
            value: function lastBefore(element) {
                if (element == null) throw "Invalid arguments(s)";
                if (this.root == null) return null;
                var comp = this.splay(element);
                if (comp < 0) return this.root.key;
                var node = this.root.left;
                if (node == null) return null;
                var nodeRight = node.right;
                while(nodeRight != null){
                    node = nodeRight;
                    nodeRight = node.right;
                }
                return node.key;
            }
        },
        {
            key: "firstAfter",
            value: function firstAfter(element) {
                if (element == null) throw "Invalid arguments(s)";
                if (this.root == null) return null;
                var comp = this.splay(element);
                if (comp > 0) return this.root.key;
                var node = this.root.right;
                if (node == null) return null;
                var nodeLeft = node.left;
                while(nodeLeft != null){
                    node = nodeLeft;
                    nodeLeft = node.left;
                }
                return node.key;
            }
        },
        {
            key: "retainAll",
            value: function retainAll(elements) {
                var retainSet = new SplayTreeSet(this.compare, this.validKey);
                var modificationCount = this.modificationCount;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var object = _step.value;
                        if (modificationCount != this.modificationCount) {
                            throw "Concurrent modification during iteration.";
                        }
                        if (this.validKey(object) && this.splay(object) == 0) {
                            retainSet.add(this.root.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (retainSet.size != this.size) {
                    this.root = retainSet.root;
                    this.size = retainSet.size;
                    this.modificationCount++;
                }
            }
        },
        {
            key: "lookup",
            value: function lookup(object) {
                if (!this.validKey(object)) return null;
                var comp = this.splay(object);
                if (comp != 0) return null;
                return this.root.key;
            }
        },
        {
            key: "intersection",
            value: function intersection(other) {
                var result = new SplayTreeSet(this.compare, this.validKey);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (other.has(element)) result.add(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "difference",
            value: function difference(other) {
                var result = new SplayTreeSet(this.compare, this.validKey);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (!other.has(element)) result.add(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "union",
            value: function union(other) {
                var u = this.clone();
                u.addAll(other);
                return u;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var set = new SplayTreeSet(this.compare, this.validKey);
                set.size = this.size;
                set.root = this.copyNode(this.root);
                return set;
            }
        },
        {
            key: "copyNode",
            value: function copyNode(node) {
                if (node == null) return null;
                function copyChildren(node, dest) {
                    var left;
                    var right;
                    do {
                        left = node.left;
                        right = node.right;
                        if (left != null) {
                            var newLeft = new SplayTreeSetNode(left.key);
                            dest.left = newLeft;
                            copyChildren(left, newLeft);
                        }
                        if (right != null) {
                            var newRight = new SplayTreeSetNode(right.key);
                            dest.right = newRight;
                            node = right;
                            dest = newRight;
                        }
                    }while (right != null);
                }
                var result = new SplayTreeSetNode(node.key);
                copyChildren(node, result);
                return result;
            }
        },
        {
            key: "toSet",
            value: function toSet() {
                return this.clone();
            }
        },
        {
            key: "entries",
            value: function entries() {
                return new SplayTreeSetEntryIterableIterator(this.wrap());
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this[Symbol.iterator]();
            }
        },
        {
            key: "values",
            value: function values() {
                return this[Symbol.iterator]();
            }
        },
        {
            key: _Symbol_iterator1,
            value: function value() {
                return new SplayTreeKeyIterableIterator(this.wrap());
            }
        }
    ]);
    return SplayTreeSet;
}(SplayTree);
var _Symbol_iterator2 = Symbol.iterator;
var SplayTreeIterableIterator = /*#__PURE__*/ function() {
    "use strict";
    function SplayTreeIterableIterator(tree) {
        _class_call_check(this, SplayTreeIterableIterator);
        _define_property(this, "tree", void 0);
        _define_property(this, "path", new Array());
        _define_property(this, "modificationCount", null);
        _define_property(this, "splayCount", void 0);
        this.tree = tree;
        this.splayCount = tree.getSplayCount();
    }
    _create_class(SplayTreeIterableIterator, [
        {
            key: _Symbol_iterator2,
            value: function value() {
                return this;
            }
        },
        {
            key: "next",
            value: function next() {
                if (this.moveNext()) return {
                    done: false,
                    value: this.current()
                };
                return {
                    done: true,
                    value: null
                };
            }
        },
        {
            key: "current",
            value: function current() {
                if (!this.path.length) return null;
                var node = this.path[this.path.length - 1];
                return this.getValue(node);
            }
        },
        {
            key: "rebuildPath",
            value: function rebuildPath(key) {
                this.path.splice(0, this.path.length);
                this.tree.splay(key);
                this.path.push(this.tree.getRoot());
                this.splayCount = this.tree.getSplayCount();
            }
        },
        {
            key: "findLeftMostDescendent",
            value: function findLeftMostDescendent(node) {
                while(node != null){
                    this.path.push(node);
                    node = node.left;
                }
            }
        },
        {
            key: "moveNext",
            value: function moveNext() {
                if (this.modificationCount != this.tree.getModificationCount()) {
                    if (this.modificationCount == null) {
                        this.modificationCount = this.tree.getModificationCount();
                        var node = this.tree.getRoot();
                        while(node != null){
                            this.path.push(node);
                            node = node.left;
                        }
                        return this.path.length > 0;
                    }
                    throw "Concurrent modification during iteration.";
                }
                if (!this.path.length) return false;
                if (this.splayCount != this.tree.getSplayCount()) {
                    this.rebuildPath(this.path[this.path.length - 1].key);
                }
                var node1 = this.path[this.path.length - 1];
                var next = node1.right;
                if (next != null) {
                    while(next != null){
                        this.path.push(next);
                        next = next.left;
                    }
                    return true;
                }
                this.path.pop();
                while(this.path.length && this.path[this.path.length - 1].right === node1){
                    node1 = this.path.pop();
                }
                return this.path.length > 0;
            }
        }
    ]);
    return SplayTreeIterableIterator;
}();
var SplayTreeKeyIterableIterator = /*#__PURE__*/ function(SplayTreeIterableIterator) {
    "use strict";
    _inherits(SplayTreeKeyIterableIterator, SplayTreeIterableIterator);
    function SplayTreeKeyIterableIterator() {
        _class_call_check(this, SplayTreeKeyIterableIterator);
        return _call_super(this, SplayTreeKeyIterableIterator, arguments);
    }
    _create_class(SplayTreeKeyIterableIterator, [
        {
            key: "getValue",
            value: function getValue(node) {
                return node.key;
            }
        }
    ]);
    return SplayTreeKeyIterableIterator;
}(SplayTreeIterableIterator);
var SplayTreeSetEntryIterableIterator = /*#__PURE__*/ function(SplayTreeIterableIterator) {
    "use strict";
    _inherits(SplayTreeSetEntryIterableIterator, SplayTreeIterableIterator);
    function SplayTreeSetEntryIterableIterator() {
        _class_call_check(this, SplayTreeSetEntryIterableIterator);
        return _call_super(this, SplayTreeSetEntryIterableIterator, arguments);
    }
    _create_class(SplayTreeSetEntryIterableIterator, [
        {
            key: "getValue",
            value: function getValue(node) {
                return [
                    node.key,
                    node.key
                ];
            }
        }
    ]);
    return SplayTreeSetEntryIterableIterator;
}(SplayTreeIterableIterator);
var SplayTreeValueIterableIterator = /*#__PURE__*/ function(SplayTreeIterableIterator) {
    "use strict";
    _inherits(SplayTreeValueIterableIterator, SplayTreeIterableIterator);
    function SplayTreeValueIterableIterator(map) {
        _class_call_check(this, SplayTreeValueIterableIterator);
        return _call_super(this, SplayTreeValueIterableIterator, [
            map
        ]);
    }
    _create_class(SplayTreeValueIterableIterator, [
        {
            key: "getValue",
            value: function getValue(node) {
                return node.value;
            }
        }
    ]);
    return SplayTreeValueIterableIterator;
}(SplayTreeIterableIterator);
var SplayTreeMapEntryIterableIterator = /*#__PURE__*/ function(SplayTreeIterableIterator) {
    "use strict";
    _inherits(SplayTreeMapEntryIterableIterator, SplayTreeIterableIterator);
    function SplayTreeMapEntryIterableIterator(map) {
        _class_call_check(this, SplayTreeMapEntryIterableIterator);
        return _call_super(this, SplayTreeMapEntryIterableIterator, [
            map
        ]);
    }
    _create_class(SplayTreeMapEntryIterableIterator, [
        {
            key: "getValue",
            value: function getValue(node) {
                return [
                    node.key,
                    node.value
                ];
            }
        },
        {
            key: "replaceValue",
            value: function replaceValue(value) {
                if (this.modificationCount != this.tree.getModificationCount()) {
                    throw "Concurrent modification during iteration.";
                }
                if (this.splayCount != this.tree.getSplayCount()) {
                    this.rebuildPath(this.path[this.path.length - 1].key);
                }
                var last = this.path.pop();
                var newLast = last.replaceValue(value);
                if (!this.path.length) {
                    this.tree.setRoot(newLast);
                } else {
                    var parent = this.path[this.path.length - 1];
                    if (last === parent.left) {
                        parent.left = newLast;
                    } else {
                        parent.right = newLast;
                    }
                }
                this.path.push(newLast);
                var count = this.tree.getSplayCount() + 1;
                this.tree.setSplayCount(count);
                this.splayCount = count;
            }
        }
    ]);
    return SplayTreeMapEntryIterableIterator;
}(SplayTreeIterableIterator);
